const namedSteps = {
    props: {
        class: { default: '' },
        steps: { default() { return [] } },
        setCurrent: { default: '' },
        iniStep: { default: '' }
    },
    template: `<div :class="routeClass">
  <div :class="headerClass">
    <slot name="header"></slot>
  </div>
  <div :class="bodyClass">
    <slot name="default" :is="is" :goTo="goTo" :prevStep="prevStep" :prev="prev" :next="next" :current="current"></slot>
  </div>
</div>`,
    data() {
        return {
            current: this.iniStep ? this.iniStep : this.steps[0],
            history: []
        }
    },
    created() {
        if (this.setCurrent) {
            const indx = parseInt(this.setCurrent)

            if (isNaN(indx) && this.getIndex(this.setCurrent) >= 0) {
                this.current = this.setCurrent
            } else {
                if (indx >= 0) {
                    this.current = this.getNameByIndex(indx)
                }
            }
        }
    },
    beforeUnmount() {
        this.$emit('unmounted', this.current)
    },
    mounted() {
        this.$emit('current', this.current)
    },
    methods: {
        is(name) {
            if (this.getIndex(name) >= 0) {
                return name === this.current
            } else {
                return false
            }
        },
        getIndex(name) {
            return this.steps.indexOf(name)
        },
        getNameByIndex(indx) {
            if (indx >= 0) {
                return this.steps[indx]
            } else {
                return false
            }
        },
        goTo(name) {
            if (this.steps.indexOf(name) >= 0) {
                if (this.current) {
                    this.history.push(this.current);
                }
                this.current = name
                this.$emit('went', this.current)
                this.$emit('current', this.current)
                return this.current
            } else {
                return false
            }
        },
        prev() {
            const indx = this.steps.indexOf(this.current)
            if (indx > 0) {
                this.current = this.steps[indx - 1]
                this.$emit('back', this.current)
                this.$emit('current', this.current)
                return this.current
            } else {
                return false
            }
        },
        prevStep() {
            if (this.history.length) {
                // const previous = this.history[this.history.length - 2] more accurate code but has some bugs. Needs improvement to implement it;
                const previous = this.history.pop();
                if(previous) {
                    this.current = previous;
                    return this.current;
                }
            }
            return false
        },
        next() {
            const indx = this.steps.indexOf(this.current)
            if (indx < this.steps.length - 1) {
                this.current = this.steps[indx + 1]
                this.$emit('forth', this.current)
                this.$emit('current', this.current)
                return this.current
            } else {
                return false
            }
        },
        get() {
            return this.current
        },
        isFirstStep(){
            const indx = this.steps.indexOf(this.current)
            return indx === 0
        }
    },
    computed: {
        routeClass() {
            return this.class === '' ? 'named-steps' : this.class
        },
        headerClass() {
            return `${this.routeClass}__header`
        },
        bodyClass() {
            return `${this.routeClass}__body`
        }
    }
}